import { defineStore } from "pinia";
import { computed } from "vue";
import { useFirestore, useCurrentUser, useDocument } from "vuefire";
import { doc } from "firebase/firestore";

export const usePaymentStore = defineStore("payment", () => {
  const db = useFirestore();
  const currentUser = useCurrentUser();

  const userDocRef = computed(() => {
    const uid = currentUser.value?.uid;
    return uid ? doc(db, "users", uid) : null;
  });

  // Get the user document from Firestore once we have a UID
  const { data: userData, pending: userDataPending } = useDocument(userDocRef);

  const isSubscribed = computed(() => {
    if (!userDocRef.value || userDataPending.value) {
      // not loaded yet
      return undefined;
    }

    const subscriptions = userData.value?.subscriptions || {};
    const subscriptionStatuses = {};

    for (const [bank, subscription] of Object.entries(subscriptions)) {
      const subscriptionDate = new Date(subscription.date.seconds * 1000);

      const lengthString = subscription.length; // e.g., "12mo", "2wk"

      // Extract numeric value and unit (mo or wk)
      const lengthMatch = lengthString.match(/^(\d+)(mo|wk)$/);
      if (!lengthMatch) {
        console.warn(
          `Invalid subscription length format for ${bank}: ${lengthString}`
        );
        continue; // Skip this subscription if format is invalid
      }

      const numericLength = parseInt(lengthMatch[1]);
      const unit = lengthMatch[2];

      const expiryDate = new Date(subscriptionDate);

      // Calculate expiry date based on the unit
      if (unit === "mo") {
        expiryDate.setMonth(expiryDate.getMonth() + numericLength);
      } else if (unit === "wk") {
        expiryDate.setDate(expiryDate.getDate() + numericLength * 7); // Add weeks in days
      }

      subscriptionStatuses[bank] = {
        val: new Date() <= expiryDate,
        endDate: expiryDate,
      };
    }

    return subscriptionStatuses;
  });

  return {
    isSubscribed,
  };
});
